/**
 * SOIREVE Product Page JS
 * - サムネイル切り替え
 * - バリアント選択 → 価格・在庫リアルタイム更新
 * - アコーディオン
 * - カートAJAX追加 → カートページへリダイレクト
 * - 関連商品 Lazy Load（Shopify Recommendations API）
 */

(function () {
  'use strict';

  /* ── ① ギャラリー ── */
  const gallery  = document.getElementById('spGallery');
  if (gallery) {
    const slides = [...gallery.querySelectorAll('.sp-gallery__slide')];
    const thumbs = [...gallery.querySelectorAll('.sp-gallery__thumb')];

    function showSlide(idx) {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
    }
    thumbs.forEach(btn => {
      btn.addEventListener('click', () => showSlide(Number(btn.dataset.index)));
    });
  }

  /* ── ② バリアント選択 ── */
  const productData = window.__soirProductData;
  const variantIdInput = document.getElementById('spVariantId');
  const priceEl        = document.getElementById('spPrice');
  const availEl        = document.getElementById('spAvailability');
  const addBtn         = document.getElementById('spAddToCart');

  document.querySelectorAll('.sp-option__size-btn, .sp-option__swatch').forEach(btn => {
    btn.addEventListener('click', () => {
      const idx = Number(btn.dataset.optionIndex);
      const val = btn.dataset.optionValue;

      document.querySelectorAll(`[data-option-index="${idx}"]`).forEach(b => {
        b.classList.toggle('is-selected', b.dataset.optionValue === val);
        if (b.tagName === 'BUTTON') b.setAttribute('aria-pressed', b.dataset.optionValue === val ? 'true' : 'false');
      });

      const label = document.getElementById(`spOptionValue-${idx}`);
      if (label) label.textContent = val;

      updateVariant();
    });
  });

  document.querySelectorAll('.sp-option__select').forEach(sel => {
    sel.addEventListener('change', () => {
      const idx = Number(sel.dataset.optionIndex);
      const label = document.getElementById(`spOptionValue-${idx}`);
      if (label) label.textContent = sel.value;
      updateVariant();
    });
  });

  function getSelectedOptions() {
    const opts = {};
    document.querySelectorAll('.sp-option').forEach(group => {
      const idx = group.dataset.optionIndex;
      const active = group.querySelector('.is-selected');
      const sel    = group.querySelector('.sp-option__select');
      if (active) opts[idx] = active.dataset.optionValue;
      else if (sel) opts[idx] = sel.value;
    });
    return opts;
  }

  function updateVariant() {
    if (!productData) return;
    const selected = getSelectedOptions();
    const variant = productData.variants.find(v =>
      v.options.every((opt, i) => opt === selected[i])
    );
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    if (priceEl) {
      const money = n => '¥' + n.toLocaleString();
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML = `
          <span class="sp-info__price-original">${money(variant.compare_at_price / 100)}</span>
          <span class="sp-info__price-sale">${money(variant.price / 100)}</span>
          <span class="sp-info__price-note">（税込）</span>`;
      } else {
        priceEl.innerHTML = `
          <span class="sp-info__price-main">${money(variant.price / 100)}</span>
          <span class="sp-info__price-note">（税込）</span>`;
      }
    }

    if (availEl) {
      availEl.innerHTML = variant.available
        ? '<span class="sp-info__avail-dot sp-info__avail-dot--in"></span> 在庫あり'
        : '<span class="sp-info__avail-dot sp-info__avail-dot--out"></span> 在庫なし';
    }
    if (addBtn) {
      addBtn.disabled    = !variant.available;
      addBtn.textContent = variant.available ? 'カートに入れる' : '在庫なし';
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  /* ── ③ カート AJAX → カートページへ遷移 ── */
  const form = document.querySelector(`[id^="soirProductForm"]`);
  if (form && addBtn) {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const variantId = variantIdInput ? variantIdInput.value : null;
      if (!variantId) return;

      addBtn.disabled    = true;
      addBtn.textContent = '追加中...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        const item = await res.json();

        if (item.status) throw new Error(item.description || 'エラーが発生しました');

        addBtn.textContent = '✓ カートに追加しました';

        // カートカウント更新
        try {
          const cartRes  = await fetch('/cart.js');
          const cartData = await cartRes.json();
          const countEl = document.getElementById('soirCartCount');
          if (countEl) countEl.textContent = cartData.item_count;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
        } catch (_) {}

        // カートページへリダイレクト（1秒後）
        setTimeout(() => {
          window.location.href = '/cart';
        }, 1000);

      } catch (err) {
        addBtn.disabled    = false;
        addBtn.textContent = err.message || 'もう一度お試しください';
        setTimeout(() => { addBtn.textContent = 'カートに入れる'; }, 3000);
      }
    });
  }

  /* ── ④ アコーディオン ── */
  document.querySelectorAll('.sp-accordion__header').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const bodyId   = btn.getAttribute('aria-controls');
      const body     = document.getElementById(bodyId);
      btn.setAttribute('aria-expanded', !expanded);
      if (body) { if (expanded) body.hidden = true; else body.hidden = false; }
    });
  });

  /* ── ⑤ 関連商品 Lazy Load ── */
  const recoEl = document.getElementById('productRecommendations');
  if (recoEl) {
    fetch(recoEl.dataset.url)
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc    = parser.parseFromString(html, 'text/html');
        const inner  = doc.querySelector('.sp-related');
        if (inner) recoEl.replaceWith(inner);
      })
      .catch(() => { /* silent */ });
  }

})();
